import Button from "@/common/components/Button"
import Modal from "@/common/components/Modal"
import { ContactData } from "@/features/privateCompanyLeadsFunnel/types/privateCompanyLead"
import { useResendContactEmail } from "@/features/privateCompanyLeadsFunnel/hooks/useResendContactEmail"
import { useState } from "react"
import { ModalMessageSimple } from "../ModalMessageSimple"

export const ResentContactEmailModal = ({ contacts }: {contacts: ContactData[]}) => {  
  const [message, setMessage] = useState<any>(null);
  const [isError, setIsError] = useState(false);

  const { mutate: resendEmail, isPending } = useResendContactEmail({
    onSuccess: () => {
      setMessage(["Enviado com sucesso"]);
      setIsError(false);
    },
    onError: (error) => {
      setMessage(error.response?.data.errors.base || ['Ocorreu um erro ao reenviar o e-mail']);
      setIsError(true);
    }
  });

  const handleResendEmail = (contactId: string, email: string) => {
    resendEmail({
      contactId,
      funnel_contact: {
        email
      }
    });
  };

  return (
    <>   
      <Modal 
          Trigger={<Button>Reenviar para contatos</Button>}
          title="Reenviar e-mail de contato"
          bodyClassName="!text-white"
          className="!text-white"
          body={(contacts.length > 0) ?
          <div className="space-y-4" style={{color: "#ffffff"}}>
            <p>
                Selecione os contatos para reenviar o e-mail:
            </p>
            <div className="space-y-3">
                {contacts?.map((contact) => (
                    <div key={contact.id} className="flex items-center justify-between p-3 rounded bg-neutral-800 !text-white">
                        <div className="flex-1">
                            <p className="font-medium">{contact.full_name || 'Nome não informado'}</p>
                            <p className="text-sm">{contact.email || 'Email não informado'}</p>
                        </div>
                        <Button
                            onClick={() => handleResendEmail(contact.id, contact.email || '')}
                            disabled={isPending}
                            isLoading={isPending}
                            variant={"default"}
                        >
                            {isPending ? 'Enviando...' : 'Reenviar'}
                        </Button>
                    </div>
                ))}
                {(!contacts || contacts.length === 0) && (
                    <p className="text-center py-4">
                        Nenhum contato encontrado 
                    </p>
                )}
            </div>
        </div> : <p>Nenhum contato encontrado</p>}
      />
      {
        message && <ModalMessageSimple isError={isError} messages={message} setMessages={setMessage}/>
      }
    </>
  )
}